import CrudCustom from '../../../libs/custom/CrudCustom';


let KertasKerjaAsetService = new CrudCustom('/sanding-aset-kertas-kerjas');
export default KertasKerjaAsetService;
